module.exports = __webpack_public_path__ + "static/media/perfil.4788048f.png";


//////////////////
// WEBPACK FOOTER
// ./src/perfil.png
// module id = 829
// module chunks = 0